<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

<dashboard-manager [cerrixTab]="tab" (load)="loadDashboard($event)"></dashboard-manager>

@if (!tab.showLoader && dashboard) {
    <div class="main-dashboard">
        <div class="detail-page-action-bar" data-uiid="dashboard">
            @if (editMode) {
                <!-- Edit Mode toolbar -->
                <ng-container>
                    <button class="btn btn-cerrix" (click)="toggleEdit()">
                        <i class="far fa-check"></i>
                        <span class="d-none d-lg-inline">{{
                            "dashboardPage.doneEditingButton" | t
                        }}</span>
                    </button>

                    <div class="right-actions right-actions-editmode">
                        <button
                            class="btn btn-secondary-outline"
                            [disabled]="showMarket"
                            (click)="openMarket()"
                        >
                            <i class="fad fa-layer-plus"></i>
                            <span class="d-none d-lg-inline">{{
                                "dashboardPage.addWidgetButton" | t
                            }}</span>
                        </button>

                        <button
                            class="btn btn-secondary-outline"
                            [disabled]="showMainConfig"
                            (click)="openMainSettings()"
                        >
                            <i class="fad fa-cogs"></i>
                            <span class="d-none d-lg-inline">{{
                                "dashboardPage.settingsButton" | t
                            }}</span>
                        </button>
                    </div>
                </ng-container>
            } @else {
                <!-- Non Edit Mode toolbar -->
                <ng-container>
                    <div class="dashboard-name">
                        <cerrix-icon-viewer [icon]="dashboard.icon"></cerrix-icon-viewer>
                        @if (dashboard.name) {
                            <span>
                                {{
                                    dashboard.name.length > 25
                                        ? (dashboard.name | slice: 0 : 25) + "..."
                                        : dashboard.name
                                }}
                            </span>
                        } @else {
                            <span>{{ "dashboardPage.newDashboardLabel" | t }}</span>
                        }
                    </div>

                    <div class="seperator"></div>

                    <button
                        class="btn btn-secondary-outline"
                        [disabled]="editMode"
                        (click)="globalFilterComp.open()"
                    >
                        <i class="fad fa-filter"></i>
                        <span> {{ "dashboardPage.filterButton" | t }} </span>
                    </button>

                    <div class="right-actions">
                        @if (dashboard._unsavedChanges) {
                            <button class="button colored" (click)="dashboard.api.save(true)">
                                <i class="fad fa-save"></i>
                                <span class="d-none d-lg-inline">{{
                                    "dashboardPage.saveChangesButton" | t
                                }}</span>
                            </button>
                        }

                        @if (dashboard.canEdit) {
                            <button class="button colored" (click)="toggleEdit()">
                                <i class="far fa-pencil"></i>
                            </button>
                        }

                        @if (dashboard._unsavedChanges) {
                            <div class="seperator"></div>
                        }

                        @if (dashboard.guid) {
                            <button class="button colored" (click)="loadDashboard(dashboard)">
                                <i class="far fa-sync"></i>
                            </button>

                            <button class="button colored" (click)="dashboard.api.setDefault()">
                                <i class="{{ dashboard.default ? 'fas' : 'far' }} fa-house"></i>
                            </button>

                            <button
                                class="button"
                                [disabled]="editMode || dashboard.default"
                                (click)="dashboard.api.toggleFavorite()"
                            >
                                <i
                                    class="{{
                                        dashboard.favorite ? 'fas orange' : 'far colored'
                                    }} fa-star"
                                ></i>
                            </button>
                        }
                    </div>
                </ng-container>
            }

            <global-filtering
                [widgets]="widgets"
                [filterValues]="dashboard.globalFilterValues"
                #globalFilterComp
            ></global-filtering>
        </div>

        <div class="window-splitter">
            <gridster
                [options]="gridster"
                [class.configopen]="showConfigFor"
                [class.isediting]="editMode"
                (scroll)="onScroll()"
            >
                @for (widget of widgets; track widget) {
                    <gridster-item
                        [item]="widget.customConfig.gridsterConfig"
                        [class.bringtofront]="showConfigFor == widget"
                    >
                        <dashboard-widget
                            [config]="widget"
                            [globalFilters]="dashboard.globalFilterValues"
                        ></dashboard-widget>
                        @if (editMode) {
                            <div class="edit-overlay">
                                <div class="edit-buttons">
                                    <button class="button" (click)="openConfig(widget, $event)">
                                        <i class="far fa-cog fa-fw"></i>
                                    </button>
                                    <button
                                        class="button red"
                                        (mousedown)="removeItem(widget, $event)"
                                    >
                                        <i class="far fa-trash fa-fw"></i>
                                    </button>
                                </div>
                            </div>
                        }
                    </gridster-item>
                }
            </gridster>

            @if (showMainConfig || showMarket || showConfigFor) {
                <div class="side-menu">
                    <div class="side-menu-content">
                        @if (showMainConfig) {
                            <dashboard-configuration
                                [config]="dashboard"
                                (change)="changedOptions()"
                            ></dashboard-configuration>
                        }

                        @if (showMarket) {
                            <widget-market></widget-market>
                        }

                        @if (showConfigFor) {
                            <widget-configuration [config]="showConfigFor"></widget-configuration>
                        }
                    </div>
                    <div class="side-menu-buttons">
                        <button class="btn btn-cerrix" (click)="hidePopup()">
                            {{ "dashboardPage.doneButton" | t }}
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
}
